import { getSocialPlatformDisplayName } from '../../lib/get-social-platform-display-name';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import {
  editCardPublishedInPlatformsMessage,
  editCardPublishedOnSinglePlatformMessage,
} from './edit-card-published-platforms-messages';

export interface EditCardPublishedPlatformsLabelProps {
  /** Number of platforms with a completed publish for this edit. */
  completedPlatformCount: number;
  /** When count is 1, API platform key (e.g. YOUTUBE) for a named label. */
  singleCompletedPlatformKey: string | null;
}

/**
 * Replaces the publish action on generated edits that already have at least one successful publication.
 */
export function EditCardPublishedPlatformsLabel({
  completedPlatformCount,
  singleCompletedPlatformKey,
}: EditCardPublishedPlatformsLabelProps) {
  const { formatMessage: $t } = useIntl();

  let text: string;
  if (singleCompletedPlatformKey != null) {
    text = $t(editCardPublishedOnSinglePlatformMessage, {
      platform: getSocialPlatformDisplayName(singleCompletedPlatformKey),
    });
  } else {
    text = $t(editCardPublishedInPlatformsMessage, { count: completedPlatformCount });
  }

  return (
    <Typography variant="body2" color="text.secondary" component="span">
      {text}
    </Typography>
  );
}
